module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-home"
  }, [_c('ModalForm'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "fp"
    }
  }, [_c('div', {
    staticClass: "section section1"
  }, [_c('Top'), _vm._v(" "), _c('div', {
    staticClass: "uk-section uk-section-small uk-section-default"
  }, [_c('div', {
    staticClass: "uk-container uk-container-large uk-margin"
  }, [(_vm.media == 'l') ? _c('div', {
    staticClass: "uk-grid uk-text-center",
    attrs: {
      "uk-grid": ""
    }
  }, [_c('div', {
    staticClass: "uk-width-1-5",
    class: {
      'uk-animation-slide-left': _vm.pageIndex == 1,
      'uk-hidden': _vm.pageIndex != 1
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "uk-width-3-5 uk-padding-small uk-padding-remove-vertical",
    class: {
      'uk-animation-fade': _vm.pageIndex == 1,
      'uk-hidden': _vm.pageIndex != 1
    }
  }, [_c('div', {
    staticClass: "uk-card uk-card-default uk-cover-container uk-height-1-1 uk-box-shadow-large uk-border-rounded"
  }, [_c('video', {
    staticClass: "uk-height-1-1",
    attrs: {
      "data-autoplay": "",
      "uk-cover": "",
      "autoplay": "",
      "loop": "",
      "muted": ""
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": "https://img.file.artsdoor.org/yidaointro.mp4",
      "type": "video/mp4"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "uk-width-1-5",
    class: {
      'uk-animation-slide-right': _vm.pageIndex == 1,
      'uk-hidden': _vm.pageIndex != 1
    }
  }, [_vm._m(1)])]) : _vm._e(), _vm._v(" "), (_vm.media == 'l') ? _c('div', {
    staticClass: "uk-container uk-container-small uk-padding-small",
    class: {
      'uk-animation-fade': _vm.pageIndex == 1,
      'uk-hidden': _vm.pageIndex != 1
    },
    staticStyle: {
      "animation-delay": ".5s"
    }
  }, [_vm._m(2), _vm._v(" "), _vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.media == 'm') ? _c('div', {
    staticClass: "uk-text-center",
    class: {
      'uk-animation-fade': _vm.pageIndex == 1,
      'uk-hidden': _vm.pageIndex != 1
    }
  }, [_c('div', {
    staticClass: "uk-card uk-card-default uk-width1-1 uk-box-shadow-large uk-border-rounded"
  }, [_c('video', {
    staticClass: "uk-width1-1 uk-border-rounded",
    attrs: {
      "data-autoplay": "",
      "autoplay": "",
      "loop": "",
      "muted": ""
    },
    domProps: {
      "muted": true
    }
  }, [_c('source', {
    attrs: {
      "src": "https://img.file.artsdoor.org/yidaointro.mp4",
      "type": "video/mp4"
    }
  })])])]) : _vm._e()]), _vm._v(" "), (_vm.media == 'm') ? _c('div', {
    staticClass: "uk-container uk-container-small uk-padding-small",
    class: {
      'uk-animation-fade': _vm.pageIndex == 1,
      'uk-hidden': _vm.pageIndex != 1
    },
    staticStyle: {
      "animation-delay": ".5s"
    }
  }, [_vm._m(4), _vm._v(" "), _vm._m(5)]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "section section2"
  }, [_c('div', {
    staticClass: "uk-height-1-1",
    class: {
      'uk-section uk-section-small uk-section-default ': _vm.media == 'l',
      'uk-padding-small': _vm.media == 'm'
    }
  }, [_c('div', {
    staticClass: "uk-height-1-1",
    class: {
      'uk-container  uk-container-expand ': _vm.media == 'l'
    }
  }, [_c('div', {
    staticClass: "card-bg uk-card uk-card-default uk-width-1-1 uk-inline uk-card-body uk-height-1-1 uk-background-cover uk-background-norepeat uk-box-shadow-large uk-border-rounded"
  }, [_c('div', {
    staticClass: "uk-position-center",
    class: {
      'uk-padding-small': _vm.media == 'm'
    }
  }, [_c('div', {
    class: {
      'uk-animation-fade': _vm.pageIndex == 2,
      'uk-hidden': _vm.pageIndex != 2
    },
    domProps: {
      "innerHTML": _vm._s(_vm.activeMsg)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "uk-grid uk-padding uk-text-center",
    attrs: {
      "uk-grid": ""
    }
  }, [_c('div', {
    class: {
      'uk-width-1-2': _vm.media == 'm',
      'uk-width-1-4': _vm.media == 'l',
      active: _vm.activeTab == 1,
      'uk-animation-slide-left': _vm.pageIndex == 2,
      'uk-hidden': _vm.pageIndex != 2
    }
  }, [_c('div', {
    staticClass: "uk-card uk-card-hover",
    on: {
      "click": function($event) {
        return _vm.clickTab(1)
      }
    }
  }, [_c('img', {
    staticClass: "uk-border-circle",
    attrs: {
      "src": require("../assets/images/liao.png")
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "uk-margin"
  }, [_vm._v("廖昌永")])])]), _vm._v(" "), _c('div', {
    class: {
      'uk-width-1-2': _vm.media == 'm',
      'uk-width-1-4': _vm.media == 'l',
      active: _vm.activeTab == 2,
      'uk-animation-slide-left': _vm.pageIndex == 2,
      'uk-hidden': _vm.pageIndex != 2
    },
    staticStyle: {
      "animation-delay": ".3s"
    }
  }, [_c('div', {
    staticClass: "uk-card uk-card-hover",
    on: {
      "click": function($event) {
        return _vm.clickTab(2)
      }
    }
  }, [_c('img', {
    staticClass: "uk-border-circle",
    attrs: {
      "src": require("../assets/images/luo.png")
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "uk-margin"
  }, [_vm._v("罗魏")])])]), _vm._v(" "), _c('div', {
    class: {
      'uk-width-1-2': _vm.media == 'm',
      'uk-width-1-4': _vm.media == 'l',
      active: _vm.activeTab == 3,
      'uk-animation-slide-left': _vm.pageIndex == 2,
      'uk-hidden': _vm.pageIndex != 2
    },
    staticStyle: {
      "animation-delay": ".6s"
    }
  }, [_c('div', {
    staticClass: "uk-card uk-card-hover",
    on: {
      "click": function($event) {
        return _vm.clickTab(3)
      }
    }
  }, [_c('img', {
    staticClass: "uk-border-circle",
    attrs: {
      "src": require("../assets/images/zhou.png")
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "uk-margin"
  }, [_vm._v("周温玉")])])]), _vm._v(" "), _c('div', {
    class: {
      'uk-width-1-2': _vm.media == 'm',
      'uk-width-1-4': _vm.media == 'l',
      active: _vm.activeTab == 4,
      'uk-animation-slide-left': _vm.pageIndex == 2,
      'uk-hidden': _vm.pageIndex != 2
    },
    staticStyle: {
      "animation-delay": ".9s"
    }
  }, [_c('div', {
    staticClass: "uk-card uk-card-hover",
    on: {
      "click": function($event) {
        return _vm.clickTab(4)
      }
    }
  }, [_c('img', {
    staticClass: "uk-border-circle",
    attrs: {
      "src": require("../assets/images/wang.png")
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "uk-margin"
  }, [_vm._v("汪任酩")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "section section3"
  }, [_c('div', {
    staticClass: "uk-section uk-section uk-section-default"
  }, [_c('div', {
    staticClass: "uk-container uk-container-small",
    class: {
      'uk-animation-scale-up': _vm.pageIndex == 3,
      'uk-hidden': _vm.pageIndex != 3
    }
  }, [_vm._m(6)]), _vm._v(" "), _c('div', {
    staticClass: "uk-container",
    class: {
      'uk-margin-large-top': _vm.media == 'l',
      'uk-margin-top': _vm.media == 'm'
    }
  }, [_c('div', {
    staticClass: "uk-grid uk-grid-small",
    class: {
      'uk-child-width-1-4': _vm.media == 'l',
      'uk-child-width-1-2': _vm.media == 'm'
    },
    attrs: {
      "uk-grid": ""
    }
  }, [_c('div', [_c('div', {
    staticClass: "uk-card uk-text-center uk-card-hover uk-border-rounded",
    class: {
      'uk-padding-small': _vm.media == 'l',
      'uk-animation-fade': _vm.pageIndex == 3,
      'uk-hidden': _vm.pageIndex != 3
    },
    attrs: {
      "id": "card-1"
    },
    on: {
      "mouseenter": function($event) {
        return _vm.hoverIconCard($event)
      },
      "mouseleave": function($event) {
        return _vm.mouseOutCard($event)
      }
    }
  }, [_c('div', {
    staticClass: "uk-card-media-top"
  }, [_c('div', {
    staticClass: "livicon-evo uk-align-center",
    attrs: {
      "data-options": 'name:thumbnails-big;' + (_vm.media == 'm' ? _vm.iconOptions_m : _vm.iconOptions)
    }
  })]), _vm._v(" "), _vm._m(7)])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "uk-card uk-text-center uk-card-hover uk-border-rounded",
    class: {
      'uk-padding-small': _vm.media == 'l',
      'uk-animation-fade': _vm.pageIndex == 3,
      'uk-hidden': _vm.pageIndex != 3
    },
    staticStyle: {
      "animation-delay": ".2s"
    },
    attrs: {
      "id": "card-2"
    },
    on: {
      "mouseenter": function($event) {
        return _vm.hoverIconCard($event)
      },
      "mouseleave": function($event) {
        return _vm.mouseOutCard($event)
      }
    }
  }, [_c('div', {
    staticClass: "uk-card-media-top"
  }, [_c('div', {
    staticClass: "livicon-evo uk-align-center",
    attrs: {
      "data-options": 'name:thumbnails-big;' + (_vm.media == 'm' ? _vm.iconOptions_m : _vm.iconOptions)
    }
  })]), _vm._v(" "), _vm._m(8)])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "uk-card uk-text-center uk-card-hover uk-border-rounded",
    class: {
      'uk-padding-small': _vm.media == 'l',
      'uk-animation-fade': _vm.pageIndex == 3,
      'uk-hidden': _vm.pageIndex != 3
    },
    staticStyle: {
      "animation-delay": ".4s"
    },
    attrs: {
      "id": "card-3"
    },
    on: {
      "mouseenter": function($event) {
        return _vm.hoverIconCard($event)
      },
      "mouseleave": function($event) {
        return _vm.mouseOutCard($event)
      }
    }
  }, [_c('div', {
    staticClass: "uk-card-media-top"
  }, [_c('div', {
    staticClass: "livicon-evo uk-align-center",
    attrs: {
      "data-options": 'name:thumbnails-big;' + (_vm.media == 'm' ? _vm.iconOptions_m : _vm.iconOptions)
    }
  })]), _vm._v(" "), _vm._m(9)])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "uk-card uk-text-center uk-card-hover uk-border-rounded",
    class: {
      'uk-padding-small': _vm.media == 'l',
      'uk-animation-fade': _vm.pageIndex == 3,
      'uk-hidden': _vm.pageIndex != 3
    },
    staticStyle: {
      "animation-delay": ".6s"
    },
    attrs: {
      "id": "card-4"
    },
    on: {
      "mouseenter": function($event) {
        return _vm.hoverIconCard($event)
      },
      "mouseleave": function($event) {
        return _vm.mouseOutCard($event)
      }
    }
  }, [_c('div', {
    staticClass: "uk-card-media-top"
  }, [_c('div', {
    staticClass: "livicon-evo uk-align-center",
    attrs: {
      "data-options": 'name:thumbnails-big;' + (_vm.media == 'm' ? _vm.iconOptions_m : _vm.iconOptions)
    }
  })]), _vm._v(" "), _vm._m(10)])])]), _vm._v(" "), _c('div', {
    staticClass: "uk-grid uk-grid-small uk-grid2",
    class: {
      'uk-child-width-1-4': _vm.media == 'l',
      'uk-child-width-1-2': _vm.media == 'm'
    },
    attrs: {
      "uk-grid": ""
    }
  }, [_c('div', [_c('div', {
    staticClass: "uk-card uk-text-center uk-card-hover uk-border-rounded",
    class: {
      'uk-padding-small': _vm.media == 'l',
      'uk-animation-fade': _vm.pageIndex == 3,
      'uk-hidden': _vm.pageIndex != 3
    },
    staticStyle: {
      "animation-delay": ".8s"
    },
    attrs: {
      "id": "card-5"
    },
    on: {
      "mouseenter": function($event) {
        return _vm.hoverIconCard($event)
      },
      "mouseleave": function($event) {
        return _vm.mouseOutCard($event)
      }
    }
  }, [_c('div', {
    staticClass: "uk-card-media-top"
  }, [_c('div', {
    staticClass: "livicon-evo uk-align-center",
    attrs: {
      "data-options": 'name:thumbnails-big;' + (_vm.media == 'm' ? _vm.iconOptions_m : _vm.iconOptions)
    }
  })]), _vm._v(" "), _vm._m(11)])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "uk-card uk-text-center uk-card-hover uk-border-rounded",
    class: {
      'uk-padding-small': _vm.media == 'l',
      'uk-animation-fade': _vm.pageIndex == 3,
      'uk-hidden': _vm.pageIndex != 3
    },
    staticStyle: {
      "animation-delay": "1s"
    },
    attrs: {
      "id": "card-6"
    },
    on: {
      "mouseenter": function($event) {
        return _vm.hoverIconCard($event)
      },
      "mouseleave": function($event) {
        return _vm.mouseOutCard($event)
      }
    }
  }, [_c('div', {
    staticClass: "uk-card-media-top"
  }, [_c('div', {
    staticClass: "livicon-evo uk-align-center",
    attrs: {
      "data-options": 'name:thumbnails-big;' + (_vm.media == 'm' ? _vm.iconOptions_m : _vm.iconOptions)
    }
  })]), _vm._v(" "), _vm._m(12)])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "uk-card uk-text-center uk-card-hover uk-border-rounded",
    class: {
      'uk-padding-small': _vm.media == 'l',
      'uk-animation-fade': _vm.pageIndex == 3,
      'uk-hidden': _vm.pageIndex != 3
    },
    staticStyle: {
      "animation-delay": "1.4s"
    },
    attrs: {
      "id": "card-8"
    },
    on: {
      "mouseenter": function($event) {
        return _vm.hoverIconCard($event)
      },
      "mouseleave": function($event) {
        return _vm.mouseOutCard($event)
      }
    }
  }, [_c('div', {
    staticClass: "uk-card-media-top"
  }, [_c('div', {
    staticClass: "livicon-evo uk-align-center",
    attrs: {
      "data-options": 'name:more;' + (_vm.media == 'm' ? _vm.iconOptions_m : _vm.iconOptions)
    }
  })]), _vm._v(" "), _vm._m(13)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "section section4"
  }, [_c('div', {
    staticClass: "uk-section uk-section-small uk-section-default uk-height-1-1"
  }, [_c('div', {
    staticClass: "uk-container uk-container-expand uk-height-1-1"
  }, [_c('div', {
    staticClass: "card-bg uk-card uk-card-default uk-width-1-1 uk-card-body uk-height-1-1 uk-box-shadow-xlarge uk-border-rounded"
  }, [_c('h1', {
    staticClass: "uk-h1 uk-text-center uk-margin-medium-top",
    class: {
      'uk-animation-slide-top': _vm.pageIndex == 4,
      'uk-hidden': _vm.pageIndex != 4
    }
  }, [_c('span', [_vm._v("联系我们")])]), _vm._v(" "), _c('div', {
    staticClass: "uk-position-center uk-width-2-3@m uk-width-1-1 uk-text-center"
  }, [_c('div', {
    staticClass: "uk-inline",
    class: {
      'uk-animation-scale-up': _vm.pageIndex == 4,
      'uk-hidden': _vm.pageIndex != 4
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/footer.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "address-card uk-card uk-card-default uk-padding uk-box-shadow-xlarge uk-border-rounded uk-overlay uk-overlay-default uk-text-left uk-text-break",
    class: {
      'uk-width-2-5 uk-position-center-right': _vm.media == 'l',
      'uk-width-1-2 uk-position-center': _vm.media == 'm'
    }
  }, [_c('h4', {
    staticClass: "uk-text-bold"
  }, [_vm._v("音悦艺道")]), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('a', {
    staticClass: "uk-button uk-button-primary uk-border-rounded",
    attrs: {
      "href": "https://forms.office.com/Pages/ResponsePage.aspx?id=DQSIkWdsW0yxEjajBLZtrQAAAAAAAAAAAAMAAJTemFpUNDVNMUtNOEtPWTRZUldDMks3WUxFQjU5Sy4u",
      "uk-toggle": ""
    }
  }, [_vm._v("留言寻求支持和帮助")])]), _vm._v(" "), _vm._m(15)])])])]), _vm._v(" "), _vm._m(16)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-padding-small uk-padding-remove-vertical"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/left.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-padding-small uk-padding-remove-vertical"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/right.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "uk-h1 uk-text-center"
  }, [_c('span', [_vm._v("音悦艺道")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "uk-h3 uk-text-center"
  }, [_c('span', [_vm._v("为您提供中国传统音乐和西方古典音乐精品教育资源、赏析资源")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "uk-h2 uk-text-center"
  }, [_c('span', [_vm._v("音悦艺道")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "uk-h3 uk-text-center"
  }, [_c('span', [_vm._v("为您提供中国传统音乐和西方古典音乐精品教育资源、赏析资源")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "uk-h1 uk-text-center"
  }, [_c('span', [_vm._v("我们提供的课程")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h4', {
    staticClass: "uk-card-title"
  }, [_vm._v("声乐课程")]), _vm._v(" "), _c('p', [_vm._v("声乐课程")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h3', {
    staticClass: "uk-card-title"
  }, [_vm._v("钢琴课程")]), _vm._v(" "), _c('p', [_vm._v("钢琴课程")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h3', {
    staticClass: "uk-card-title"
  }, [_vm._v("管乐课程")]), _vm._v(" "), _c('p', [_vm._v("管乐课程")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h3', {
    staticClass: "uk-card-title"
  }, [_vm._v("弦乐课程")]), _vm._v(" "), _c('p', [_vm._v("弦乐课程")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h3', {
    staticClass: "uk-card-title"
  }, [_vm._v("视唱练耳课程")]), _vm._v(" "), _c('p', [_vm._v("视唱练耳课程")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h3', {
    staticClass: "uk-card-title"
  }, [_vm._v("打击乐课程")]), _vm._v(" "), _c('p', [_vm._v("打击乐课程"), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h3', {
    staticClass: "uk-card-title"
  }, [_vm._v("持续更新")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "uk-text-bold"
  }, [_vm._v("沪青平公路3938弄移动智地42号音悦艺道国际艺术交流中心"), _c('br'), _vm._v("\n                          上海市青浦区"), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-phone"
  }), _vm._v(" 021-59888338 "), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-xin"
  }), _vm._v(" info@artsong.cn "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uk-position-center position-marker"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/fancy-marker.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copyright uk-container uk-text-center uk-text-bold"
  }, [_c('p', [_vm._v("Copyright © 2016-2022 "), _c('a', {
    attrs: {
      "href": "http://beian.miit.gov.cn/",
      "target": "_blank"
    }
  }, [_vm._v("沪ICP备16054728号-4")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61180a16","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 98
// module chunks = 1